// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid-feedback {
  margin-left: 3rem;
  margin-right: auto;
}
.col-form-label {
  margin-left: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/screening-edit/screening-edit.component.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;AACJ;AAEA;EACI,iBAAA;AAAJ","sourcesContent":[".invalid-feedback {\n    margin-left: 3rem;\n    margin-right: auto;\n}\n\n.col-form-label {\n    margin-left: 2rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
